import { render, staticRenderFns } from "./CadItem.vue?vue&type=template&id=22061e73&"
import script from "./CadItem.vue?vue&type=script&lang=js&"
export * from "./CadItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports